<div tabindex="0" role="status" [attr.aria-label]="ariaLabel">
    <div class="spinner">
        <div class="dot1"></div>
        <div class="dot2"></div>
    </div>
</div>
